import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslocoModule } from '@jsverse/transloco';

import { FooterContainer } from '../footer/components/footer.container';
import { DropdownFooterComponent } from './components/dropdown-footer/dropdown-footer.component';
import { EmailInputFooterComponent } from './components/email-input-footer/email-input-footer.component';
import { GlobalPipesModule } from '@app/pipes/global-pipes.module';
import { ResponsableTourismRoutingModule } from '@responsable-tourism/responsable-tourism-routing.module';
import { ResponsableTourismModule } from '@responsable-tourism/responsable-tourism.module';
import { ModalModule } from '@ux/components/modal/modal.module';
import { SpecialTravelDataModule } from '@app/modules/special-travel-data/special-travel-data.module';
import { SwipeUpModule } from '@app/modules/ux/components/swipe-up/swipe-up.module';

@NgModule({
  declarations: [FooterContainer, DropdownFooterComponent, EmailInputFooterComponent],
  imports: [
    CommonModule,
    TranslocoModule,
    GlobalPipesModule,
    ResponsableTourismRoutingModule,
    ResponsableTourismModule,
    ModalModule,
    SpecialTravelDataModule,
    SwipeUpModule
  ],
  exports: [
    FooterContainer,
    DropdownFooterComponent
  ]
})
export class FooterModule { }
